import { Link } from "@tanstack/react-router";
import { Instagram, Mail, Phone } from "lucide-react";
import { BrandLogo } from "./BrandLogo";

export function SiteFooter() {
  return (
    <footer className="bg-onyx text-bone">
      <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8">
        <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <BrandLogo className="h-8 w-auto" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-bone/70">
              DJ y producción de eventos. Sonido, iluminación, cabina, montaje y desmontaje, con
              equipo propio dimensionado sobre el espacio real.
            </p>
            <div className="mt-8 flex items-center gap-3">
              {[Instagram].map((Icon) => (
                <a
                  key="instagram"
                  href="https://instagram.com/la_susiedad"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex size-10 items-center justify-center border border-bone/15 text-bone/80 transition-colors hover:border-neon hover:text-neon"
                  aria-label="Instagram de SUSIEDAD"
                >
                  <Icon className="size-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="eyebrow text-bone/50">Navegación</p>
            <ul className="mt-5 space-y-3 text-sm text-bone/80">
              {[
                ["Inicio", "/"],
                ["Bodas", "/bodas"],
                ["Eventos", "/eventos"],
                ["Instituciones", "/public"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="hover:text-neon">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="eyebrow text-bone/50">Contacto</p>
            <ul className="mt-5 space-y-3 text-sm text-bone/80">
              <li>
                <a
                  href="mailto:lasusiedad@gmail.com"
                  className="inline-flex items-center gap-2 hover:text-neon"
                >
                  <Mail className="size-4" /> lasusiedad@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+34633199708"
                  className="inline-flex items-center gap-2 hover:text-neon"
                >
                  <Phone className="size-4" /> 633 199 708
                </a>
              </li>
              <li>
                <Link to="/contacto" className="hover:text-neon">
                  Consultar disponibilidad
                </Link>
              </li>
              <li>
                <Link to="/acceso" className="hover:text-neon">
                  Acceso privado
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="eyebrow text-bone/50">Legal</p>
            <ul className="mt-5 space-y-3 text-sm text-bone/80">
              <li>
                <Link to="/privacidad" className="hover:text-neon">
                  Política de privacidad
                </Link>
              </li>
              <li>
                <Link to="/aviso-legal" className="hover:text-neon">
                  Aviso legal
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-bone/10 pt-8 text-xs text-bone/50 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} SUSIEDAD. Todos los derechos reservados.</p>
          <p className="font-mono uppercase tracking-widest">
            Málaga · Toda España · <span className="text-neon">El momento exacto</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
